import { CompanyAssignLicenceDTO } from './../models/commercialProduct.model';
import { DialogService } from './dialog.service';
import { AppModule } from './../app.module';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UserDTO } from './../models/user.model';
import { environment } from './../../environments/environment';
import { GlobalService } from './global.service';
import { LoginResult } from '../models/loginResult.model';
import { CompanyDashboardStaticObject } from '../models/company.model';

const helper = new JwtHelperService();
const CURRENT_TOKEN_NAME: string =  "fatturexlsToken" // "MyNamirialToken" // "fatturexlsToken";
const CURRENT_MYNAMIRIAL_TOKEN: string =  "MyNamirialToken" 

//ShareXLSToken
const SHAREXLS_TOKEN_NAME: string = "sharexlsLoginObject";
const SESSION_STORAGE_COMPANY_SELECTED_NAME: string = "fattureXlsSelectedCompany";

const FROMGESTIONEUFFICI: string = "fromgestioneuffici"

@Injectable({
  providedIn: 'root'
})

/**
 * Servizio di autenticazione
 */
export class AuthService {

  public loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.tokenAvailable());

  get isLoggedIn() {
    return this.loggedIn.asObservable();
  }

  constructor(
    private http: HttpClient,
    private router: Router) {
  }

  /**
   * Effettua la login e, se login completata con successo, restituisce il token
   * @param email Email dell'utente da loggare
   * @param password Password dell'utente da loggare
   */
  login(email: string, password: string): Promise<LoginResult> {

    let loginData: any = {
      Email: email,
      Password: password,
      fromfattureplus: "1"

    };

    return this.http.post<LoginResult>(environment.apiUrl + '/api/login/login', loginData).toPromise();
  }


  mynamiriallogin(mynamirialtoken: string): Promise<LoginResult> {

    let loginData: any = {
      Email: "",
      Password: "",
      MyNamirialToken: mynamirialtoken,
      fromfattureplus: "1"
    };

    return this.http.post<LoginResult>(environment.apiUrl + '/api/login/login', loginData).toPromise();
  }


  /**
   * Al logout rimuovo l'utente dal local storage e lo indirizzo alla pagina di Login.
   *  Setto a null la company corrente e rimuovo il relativo token dal sessionStorage
   */
  logout() {
    this.sessionReset();
    this.router.navigate(['/login']);
  }

  

sessionReset(){
    this.loggedIn.next(false);
    sessionStorage.removeItem(SESSION_STORAGE_COMPANY_SELECTED_NAME);
    localStorage.removeItem(SESSION_STORAGE_COMPANY_SELECTED_NAME);
    GlobalService.currentManagedCompany = null;
    GlobalService.setCurrentCompany(null);
    GlobalService.companyDashboardStaticObject = new CompanyDashboardStaticObject();
    GlobalService.setSessionStorageFilter(null);
    localStorage.removeItem(CURRENT_TOKEN_NAME);
    localStorage.removeItem(SHAREXLS_TOKEN_NAME);
    localStorage.removeItem(CURRENT_MYNAMIRIAL_TOKEN);
    localStorage.removeItem(FROMGESTIONEUFFICI);
}

  registerCompany(newCompany: CompanyAssignLicenceDTO): Promise<any> {
    return this.http.post<any>(environment.apiUrl + '/api/auth/RegisterCompany' + "?ClientID=E1846FBA-641B-4663-973C-6CED1D778EF9", newCompany).toPromise();
  }

  /**
   * Recupera lo user dal token memorizzato nel local storage
   */
  getCurrentUser(): UserDTO {    
    let decodedToken = helper.decodeToken(this.getCurrentToken())        
    return decodedToken != undefined ? decodedToken.User : null;    
  }

  

  /**
   * Memorizza il token nel local storage
   * @param token Token da memorizzare nel local storage
   */
  setCurrentToken(token) {
    localStorage.setItem(CURRENT_TOKEN_NAME, token);
  }

  /**
   * Memorizza il token di Mynamirial nel local storage
   * @param token Token da memorizzare nel local storage
   */
  setMyNamirialToken(token) {
    localStorage.setItem(CURRENT_MYNAMIRIAL_TOKEN, token);
  }

  getNamirialAccount(): string {    
    let decodedToken = helper.decodeToken(this.getMyNamirialToken())        
    return decodedToken != undefined ? decodedToken.email : null;    
    
  }

/**
   * Imposta un flag "1" se proviene da gestione uffici in modo che
   * nella defaultlayout effettua il redirect nella lista documenti
   * in altri punti non riesce a caricare la company e 
   * da messaggio di errore
   */
  setGestioneUfficiFlag(value) {
    localStorage.setItem(FROMGESTIONEUFFICI, value);
  }

  getGestioneUfficiFlag() {
    
    let value = localStorage.getItem(FROMGESTIONEUFFICI);
    if (value == undefined || value == null) {
      value = "0";
    }
    return value;
  }

  /**
    * Memorizza il token nel local storage
    * @param token Token da memorizzare nel local storage
    */
  setCurrentShareXLSToken(sharexlsLoginObject: any) {
    localStorage.setItem(SHAREXLS_TOKEN_NAME, sharexlsLoginObject);
  }

  /**
   * Recupera il token dal local storage
   */
  getCurrentToken() {
    return localStorage.getItem(CURRENT_TOKEN_NAME);
  }

  /**
   * Recupera il token MyNamirial dal local storage
   */
  getMyNamirialToken() {
    return localStorage.getItem(CURRENT_MYNAMIRIAL_TOKEN);
  }

  /**
   * Recupera il token dal local storage
   */
  getCurrentShareXLSToken() {
    return localStorage.getItem(SHAREXLS_TOKEN_NAME);
  }

  /**
   * Restituisce TRUE se il token è disponibile
   */
  tokenAvailable(): boolean {
    let token = localStorage.getItem(CURRENT_TOKEN_NAME);
    return token != undefined && token != null;
  }

  /**
   * Restituisce TRUE se il token MyNamirla è disponibile
   */
  tokenMyNamirialAvailable(): boolean {
    let token = this.getMyNamirialToken();
    return token != undefined && token != null;
  }


}
